import { apiClient } from './client';
import { AuditLogPage, CompanyPlanStatus } from '../types/company';

export async function fetchCompanyPlanStatus(): Promise<CompanyPlanStatus> {
  const { data } = await apiClient.get<CompanyPlanStatus>('/companies/current/plan');
  return data;
}

export async function updateCompanyPlan(plan: string): Promise<CompanyPlanStatus> {
  const { data } = await apiClient.put<CompanyPlanStatus>('/companies/current/plan', { plan });
  return data;
}

export async function fetchAuditLogs(params?: {
  action?: string;
  page?: number;
  size?: number;
}): Promise<AuditLogPage> {
  const { data } = await apiClient.get<AuditLogPage>('/companies/current/audit-logs', {
    params: {
      action: params?.action || undefined,
      page: params?.page ?? 0,
      size: params?.size ?? 50,
    },
  });
  return data;
}
